import React from 'react';

// Styles & Assets
import styles from './ButtonEditForm.module.css';


// Language
import { useTranslation } from 'react-i18next';

const ButtonEditForm: React.FC<{
    label: string,
    active: boolean,
    setActive: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ label, active, setActive }) => {

    const { t } = useTranslation();

    return (
        <div>
            <h3 className={styles.buttonsLabel}>{label}</h3>
            <div className={styles.buttonFormContainer}>
                <button
                    onClick={() => setActive(true)}
                    className={`${styles.buttonForm} ${active && styles.activeButtonForm}`}
                >
                    <span>{t('yes')}</span>
                </button>
                <button
                    onClick={() => setActive(false)}
                    className={`${styles.buttonForm} ${!active && styles.activeButtonForm}`}
                >
                    <span>{t('no')}</span>
                </button>
            </div>
        </div>
    );
};

export default ButtonEditForm;